module.exports = __webpack_public_path__ + "img/gps.25072f8c.png";